import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery, queryDelete, queryGet, queryPost, queryPut } from '@/utils';

export const siblingGroupApi = createApi({
  reducerPath: 'siblingGroupApi',
  baseQuery,
  endpoints: (builder) => ({
    saveGroup: builder.mutation({
      query: ({ groupId, body }) =>
        groupId ? queryPut(`/sibling-group/${groupId}`, body) : queryPost('/sibling-group', body),
    }),
    getGroup: builder.query({
      query: ({ groupId }) => queryGet(`/sibling-group/${groupId}`),
    }),

    getGroupMembers: builder.query({
      query: ({ groupId, pageNumber = 1, pageSize = 10, ...other }) =>
        queryGet(`/sibling-group/${groupId}/members`, { pageNumber, pageSize, ...other }),
    }),
    addGroupMember: builder.mutation({
      query: (body) => queryPost('/sibling-group/members', body),
    }),
    addGroupMembers: builder.mutation({
      query: ({ groupId, body }) => queryPost(`/sibling-group/${groupId}/members`, body),
    }),
    deleteGroupMember: builder.mutation({
      query: ({ groupId, memberId }) => queryDelete(`/sibling-group/${groupId}/members/${memberId}`),
    }),
  }),
});

export const {
  useSaveGroupMutation,
  useGetGroupQuery,
  useGetGroupMembersQuery,
  useAddGroupMemberMutation,
  useAddGroupMembersMutation,
  useDeleteGroupMemberMutation,
} = siblingGroupApi;
